<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="maintainTask">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i>维修任务
        </span>
        <div class="w_normalNav" :parent="self">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn" @click="openDialog">批量导出</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="任务名称:">
                <el-input v-model="seefrom.taskName" placeholder="请输入任务名称"></el-input>
              </el-form-item>
              <el-form-item label="维保单位:">
                <el-input v-model="seefrom.deptName" placeholder="请输入维保单位名称"></el-input>
              </el-form-item>
              <el-form-item label="上报开始时间:" label-width="115px">
                <el-date-picker v-model="seefrom.beginTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择开始时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="上报结束时间:" label-width="115px">
                <el-date-picker v-model="seefrom.endTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择结束时间">
                </el-date-picker>
              </el-form-item>
              <br>
              <el-form-item label="消防设备:">
                <el-select :popper-append-to-body="false" v-model="seefrom.contentItemId" placeholder="请选择消防设备" style="width:100%">
                  <el-option v-for="(item, index) in deviceList" :key="index" :label="item.patrolContent" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="上报人员:">
                <el-input v-model="seefrom.reporterName" placeholder="请输入上报人员姓名"></el-input>
              </el-form-item>
              <el-form-item label="问题类型:">
                <el-select :popper-append-to-body="false" v-model="seefrom.type" placeholder="请选择问题类型" style="width:100%">
                  <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="维保状态:">
                <el-select :popper-append-to-body="false" v-model="seefrom.status" placeholder="请选择维保状态" style="width:100%">
                  <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper">
          <el-table :data="tableData" style="width: 100%" class="stripeTable" height="500" ref="Table">
            <el-table-column show-overflow-tooltip :label="label" :prop="prop" :align="align" :width="width" v-for="({prop,label,align, width}) in config" :key="prop.toString()"></el-table-column>
            <el-table-column label="操作" width="170">
              <template slot-scope="scope">
                <el-link icon="iconfont iconcheck" type="text" size="small" @click="check(scope.$index,  scope.row)">详情
                </el-link>
                <el-link icon="iconfont iconedit" type="text" size="small" @click="download(scope.row)" v-if="scope.row.status != 0">导出</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination layout="prev, pager, next" :page-size="10" @current-change="handleCurrentChange" :total="nTotal" :current-page="currentPage">
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <!-- 批量导出 -->
      <ledger-dialog v-model="downloadDialog"></ledger-dialog>
      <el-dialog :visible.sync="detailDialog" class="cust_dialog editDialog" title="维修详情">
        <el-form :model="detail" class="addDetail" ref="detail" label-suffix="：" style="margin: 0 40px 0 20px;">
          <el-form-item label="任务名称" prop="taskName">
            <p>{{ detail.taskName }}</p>
          </el-form-item>
          <el-form-item label="上报时间" prop="createTime">
            <p>{{ detail.createTime }}</p>
          </el-form-item>
          <el-form-item label="上报人员" prop="reporterName">
            <p>{{ detail.reporterName }}</p>
          </el-form-item>
          <el-form-item label="联系方式" prop="reporterPhone">
            <p>{{ detail.reporterPhone }}</p>
          </el-form-item>
          <el-form-item label="消防系统" prop="systemName">
            <p>{{ detail.systemName }}</p>
          </el-form-item>
          <el-form-item label="消防设备" prop="deviceName">
            <p>{{ detail.deviceName }}</p>
          </el-form-item>
          <el-form-item label="问题类型" prop="typeName">
            <p>{{ detail.typeName }}</p>
          </el-form-item>
          <el-form-item label="问题描述" prop="faultDescription">
            <p>{{ detail.faultDescription }}</p>
          </el-form-item>
          <el-form-item label="问题图片">
            <template v-if="detail.faultAnnex">
              <div style="display: flex;">
                <div v-for="(bitem, index) in detail.faultAnnex.split(',').filter((item) => item.indexOf('http') != -1)" :key="index">
                  <div>
                    <el-image :src="bitem" :preview-src-list="detail.faultAnnex.split(',').filter((item) => item.indexOf('http') != -1)" style="width: 60px; height: 60px;margin: 0 10px 10px 0;">
                      <div slot="placeholder" class="image-slot">
                        加载中<span class="dot">...</span>
                      </div>
                    </el-image>
                  </div>
                </div>
              </div>
            </template>
          </el-form-item>
          <template v-if="detail.status == 1">
            <el-form-item label="状态" prop="statusName">
              <p>{{ detail.statusName }}</p>
            </el-form-item>
            <el-form-item label="维修时间" prop="repairTime">
              <p>{{ detail.repairTime }}</p>
            </el-form-item>
            <el-form-item label="维修人员" prop="repairerName">
              <p>{{ detail.repairerName }}</p>
            </el-form-item>
            <el-form-item label="联系方式" prop="repairerPhone">
              <p>{{ detail.repairerPhone }}</p>
            </el-form-item>
            <el-form-item label="维修结果" prop="repairResult">
              <p>{{ detail.repairResult }}</p>
            </el-form-item>
            <el-form-item label="维修图片">
              <template v-if="detail.repairAnnex">
                <div style="display: flex;">
                  <div v-for="(bitem, index) in detail.repairAnnex.split(',').filter((item) => item.indexOf('http') != -1)" :key="index">
                    <div>
                      <el-image :src="bitem" :preview-src-list="detail.repairAnnex.split(',').filter((item) => item.indexOf('http') != -1)" style="width: 60px; height: 60px;margin: 0 10px 10px 0;">
                        <div slot="placeholder" class="image-slot">
                          加载中<span class="dot">...</span>
                        </div>
                      </el-image>
                    </div>
                  </div>
                </div>
              </template>
            </el-form-item>
          </template>
        </el-form>
      </el-dialog>
    </el-tabs>
  </div>
</template>

<script>
import ledgerDialog from './ledgerDialog'
import { date } from 'utils'
export default {
  name: 'maintainTask',
  data() {
    return {
      form_jsgl: {},
      items: [],
      typeList: [
        {
          label: '巡检故障',
          value: 0
        },
        {
          label: '突发故障',
          value: 1
        }
      ],
      deviceList: [],
      statusList: [
        {
          label: '待维修',
          value: 0
        },
        {
          label: '已维修',
          value: 1
        }
      ],
      tabName: 'maintainTask',
      seefrom: {},
      tableData: [],
      nTotal: 0,
      currentPage: 1,
      currentSize: 10,
      downloadDialog: false,
      detailDialog: false,
      detail: {}
    }
  },
  computed: {
    self() {
      return this
    },
    config() {
      return [
        {
          prop: 'createTime',
          label: '上报时间'
        },
        {
          prop: 'taskName',
          label: '任务名称'
        },
        {
          prop: 'deptName',
          label: '维保单位'
        },
        {
          prop: 'reporterName',
          label: '上报人员'
        },
        {
          prop: 'patrolContent',
          label: '消防设备'
        },
        {
          prop: 'typeName',
          label: '问题类型'
        },
        {
          prop: 'statusName',
          label: '状态'
        },
        {
          prop: 'repairerName',
          label: '维修人员'
        },
        {
          prop: 'repairTime',
          label: '维修时间'
        }
      ]
    }
  },
  components: {
    normalNav: () => import('public/normalNav'),
    searchForm: () => import('public/searchForm'),
    easyTable: () => import('public/easyTable'),
    ledgerDialog
  },
  methods: {
    getContentList() {
      this.$axiosget('extra/maintenanceContentItem/list').then((res) => {
        if (res.data.status == 10000) {
          this.deviceList = res.data.data
        }
      })
    },
    //搜索
    subSeefrom() {
      this.currentPage = 1
      this.getTableData()
    },
    //重置
    reset() {
      this.seefrom = {}
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getTableData()
    },
    // 每页数
    sizeChangeHandle(val) {
      this.currentSize = val
      this.currentPage = 1
      this.getTableData()
    },
    isMaxGtMin() {
      if (!this.seefrom.beginTime || !this.seefrom.endTime) return true
      let s = date(this.seefrom.beginTime)
      let e = date(this.seefrom.endTime)
      let ns = [s.YY, s.MM, s.DD].join('')
      let ne = [e.YY, e.MM, e.DD].join('')
      return ne > ns ? true : false
    },
    //查询表格数据
    getTableData() {
      if (this.seefrom.beginTime && this.seefrom.endTime) {
        if (!this.isMaxGtMin()) {
          this.$notify({
            message: '开始时间需小于结束时间',
            type: 'warning'
          })
          return
        }
      }
      this.$axiosget('extra/maintenanceRepairTask', {
        params: {
          pageSize: this.currentSize,
          pageNum: this.currentPage,
          ...this.seefrom,
          beginTime: this.seefrom.beginTime
            ? this.seefrom.beginTime + ' 00:00:00'
            : undefined,
          endTime: this.seefrom.endTime
            ? this.seefrom.endTime + ' 23:59:59'
            : undefined
        }
      }).then((res) => {
        if (res.data.data.list.length) {
          this.tableData = res.data.data.list.map((item) => {
            return {
              ...item,
              statusName: this.statusList.find(
                (bitem) => bitem.value === item.status
              ).label,
              typeName: this.typeList.find((bitem) => bitem.value === item.type)
                .label
            }
          })
        } else {
          this.tableData = []
        }
        this.nTotal = res.data.data.total
      })
    },
    changeTab(val) {
      this.activeName = val
    },
    check(index, row) {
      this.$axiospost(`extra/maintenanceRepairTask/detail/${row.id}`).then(
        (res) => {
          if (res.data.status == 10000) {
            this.detail = res.data.data
            this.detail.statusName = this.statusList.find(
              (bitem) => bitem.value === this.detail.status
            ).label
            this.detail.typeName = this.typeList.find(
              (bitem) => bitem.value === this.detail.type
            ).label
            this.detail.systemName = res.data.data.contentItem
              ? res.data.data.contentItem.fireControlSystem
              : ''
            this.detail.deviceName = res.data.data.contentItem
              ? res.data.data.contentItem.patrolContent
              : ''
            // if (
            //   this.detail.status == 1 &&
            //   !this.detail.sign &&
            //   this.form.sign.indexOf('http') === -1
            // ) {
            //   this.detail.sign = 'data:image/png;base64,' + this.detail.sign
            // }
            if (this.detail.faultAnnex) {
              let fileUrl = this.detail.faultAnnex.split(',').map((bitem) => {
                let fileUrl = process.env.fileUrl
                if (bitem && bitem.includes(fileUrl)) {
                  if (
                    process.env.SSL_ENABLE ||
                    process.env.SSL_ENABLE === 'true'
                  ) {
                    return bitem.replaceAll(
                      fileUrl,
                      process.env.SSL_HOST + '/file/'
                    )
                  } else {
                    return bitem
                  }
                } else {
                  return bitem
                }
              })
              if (fileUrl.length > 0) {
                this.detail.faultAnnex = fileUrl.join(',')
              }
            }
            if (this.detail.repairAnnex) {
              let fileUrl = this.detail.repairAnnex.split(',').map((bitem) => {
                let fileUrl = process.env.fileUrl
                if (bitem && bitem.includes(fileUrl)) {
                  if (
                    process.env.SSL_ENABLE ||
                    process.env.SSL_ENABLE === 'true'
                  ) {
                    return bitem.replaceAll(
                      fileUrl,
                      process.env.SSL_HOST + '/file/'
                    )
                  } else {
                    return bitem
                  }
                } else {
                  return bitem
                }
              })
              if (fileUrl.length > 0) {
                this.detail.repairAnnex = fileUrl.join(',')
              }
            }
            this.detailDialog = true
          }
        }
      )
    },
    download(row) {
      this.$axiospost(
        `extra/maintenanceRepairTask/export/${
          row.id
        }?companyId=${localStorage.getItem(
          'companyId'
        )}&userId=${localStorage.getItem('userId')}`,
        {
          headers: { 'Content-Type': 'application/x-msdownload' }
        }
      ).then((res) => {
        this.$message.success('下载成功!')
      })
    },
    openDialog() {
      this.downloadDialog = true
    }
  },
  created() {
    this.getContentList()
    this.getTableData()
  }
}
</script>

<style lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
</style>

<style lang="less" scoped>
.cust_dialog /deep/ .el-dialog__body {
  padding-top: 35px;
}
.cust_dialog {
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/wbManage/maintainTask/index.vue